import { render, staticRenderFns } from "./contentCourseLectureExamFillTheBlank.vue?vue&type=template&id=07220e64&"
import script from "./contentCourseLectureExamFillTheBlank.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureExamFillTheBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports